import SEOArticleLayout from "@/components/feature/SEOArticleLayout";
import { comparisonCSSBuy } from "@/mocks/articles";

export default function HipobuyVsCSSBuy() {
  return (
    <SEOArticleLayout
      slug={comparisonCSSBuy.slug}
      title={comparisonCSSBuy.title}
      metaDescription={comparisonCSSBuy.metaDescription}
      publishDate={comparisonCSSBuy.publishDate}
      readTime={comparisonCSSBuy.readTime}
      badge={comparisonCSSBuy.badge}
      heroImage={comparisonCSSBuy.heroImage}
      sections={comparisonCSSBuy.sections}
      relatedArticles={[
        { label: "Complete Guide", to: "/hipobuy-spreadsheet-complete-guide" },
        { label: "vs Kakobuy", to: "/hipobuy-spreadsheet-vs-kakobuy" },
        { label: "vs Superbuy", to: "/hipobuy-spreadsheet-vs-superbuy" },
        { label: "vs Oopbuy", to: "/hipobuy-spreadsheet-vs-oopbuy" },
        { label: "Category Deep-Dive", to: "/hipobuy-spreadsheet-category-deep-dive" },
      ]}
    />
  );
}